import React from 'react'
import PropTypes from 'prop-types'
import actions from 'redux-auto'
import {connect} from 'react-redux'

export default function UserInfoHOC(WrappedComponent, options) {
  const idPropKey = options ? options[0] : 'userId'

  function getValueOrDefault(obj, key, defaultValue = undefined) {
    if (obj) {
      return obj[key]
    }
    return defaultValue
  }

  class UserInfoHOCImpl extends React.Component {
    componentDidMount() {
      // setTimeout prevents fetching user info too many times
      // when redux is slower than expected
      setTimeout(this.getUserInfo, 200)
    }

    componentDidUpdate(prevProps) {
      if (this.props[idPropKey] !== prevProps[idPropKey]) {
        this.getUserInfo()
      }
    }

    getUserInfo = () => {
      const {userInfo, isFetchingUserInfo} = this.props
      if (!userInfo && !isFetchingUserInfo) {
        actions.userInfo.getUserInfo({userId: this.props[idPropKey]})
      }
    }

    render() {
      const {userInfo, isFetchingUserInfo, ...reducedProps} = this.props
      if (!userInfo) {
        return null
      }
      return <WrappedComponent testID="UserInfoHOCImpl" userInfo={userInfo} {...reducedProps} />
    }
  }

  UserInfoHOCImpl.propTypes = {
    userInfo: PropTypes.shape({
      name: PropTypes.string,
      role: PropTypes.string,
      profileImage: PropTypes.string,
    }),
    isFetchingUserInfo: PropTypes.bool,
  }

  function mapStateToProps(state, props) {
    return {
      userInfo: getValueOrDefault(state.userInfo.users, props[idPropKey]),
      isFetchingUserInfo: getValueOrDefault(state.userInfo.isFetching, props[idPropKey]),
    }
  }

  return connect(mapStateToProps)(UserInfoHOCImpl)
}
